import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.67676 3.64355C9.13369 2.69813 10.2315 2.25112 11.207 2.6377L11.4004 2.72656L11.4053 2.72949C11.7898 2.93323 12.1021 3.25763 12.292 3.65527L12.293 3.65723L13.5674 6.34082L16.1973 6.66797C17.3553 6.81237 18.1106 7.88064 17.9863 8.98535V8.98633C17.9333 9.45277 17.726 9.88483 17.4053 10.2168L17.4014 10.2217L15.3789 12.2861L15.7158 15.0615V15.0625C15.8533 16.2091 15.0721 17.3235 13.874 17.4814L13.875 17.4824C13.4203 17.5429 12.9631 17.4481 12.5713 17.2256V17.2266L10.46 16.0332L8.26855 17.1982L8.2666 17.1992C7.23366 17.7455 5.98759 17.3051 5.48535 16.2793V16.2783C5.29585 15.8929 5.2324 15.467 5.28809 15.0547L5.28906 15.0508L5.49316 13.5811C5.57009 13.0236 5.77303 12.4984 6.08008 12.0449C5.65518 11.921 5.25543 11.7083 4.9082 11.416L4.90723 11.415L3.75586 10.4424C2.87201 9.69582 2.75261 8.37485 3.45508 7.47363L3.45605 7.47266C3.74471 7.1032 4.15179 6.83243 4.61914 6.72266L4.82324 6.68555L7.36426 6.3457L8.67676 3.64355Z",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }